// Traduções do módulo Notas Fiscais, coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'notasFiscais.titulo': 'Notas Fiscais',
    'notasFiscais.eyebrow': 'Operação',
    'notasFiscais.relatorio': 'Notas fiscais de transporte',
    'notasFiscais.resumo.notas': 'Notas',
    'notasFiscais.resumo.semViagem': 'Sem viagem',
    'notasFiscais.resumo.emitentes': 'Emitentes',
    'notasFiscais.dica': 'Capturadas pela Qive e importadas pelo Protheus, pela data de emissão',
    'notasFiscais.filtro.de': 'De',
    'notasFiscais.filtro.ate': 'Até',
    'notasFiscais.filtro.emitente': 'Emitente',
    'notasFiscais.filtro.uf': 'UF',
    'notasFiscais.filtro.numero': 'Número',
    'notasFiscais.filtro.chave': 'Chave de acesso',
    'notasFiscais.filtro.viagem': 'Viagem',
    'notasFiscais.filtro.todas': 'Todas',
    'notasFiscais.col.emissao': 'Emissão',
    'notasFiscais.col.numero': 'Número',
    'notasFiscais.col.emitente': 'Emitente',
    'notasFiscais.col.natureza': 'Natureza da operação',
    'notasFiscais.col.chave': 'Chave de acesso',
    'notasFiscais.col.lote': 'Lote',
    'notasFiscais.col.viagem': 'Viagem',
    'notasFiscais.cfop': 'CFOP {{cfop}}',
    'notasFiscais.semViagem': 'Sem viagem',
    'notasFiscais.placa': 'Placa {{placa}}',
    'notasFiscais.foraDoModulo': 'A viagem {{numero}} ainda não está no módulo de Viagens.',
    'notasFiscais.abrirViagem': 'Abrir o detalhamento da viagem {{numero}}',
    'notasFiscais.vazio': 'Nenhuma nota fiscal no filtro.',
    'notasFiscais.export.dica': 'Baixa todas as notas do filtro, e não só a página.',
    'notasFiscais.export.vazio': 'Nenhuma nota para baixar no filtro.',
  },
  en: {
    'notasFiscais.titulo': 'Invoices',
    'notasFiscais.eyebrow': 'Operations',
    'notasFiscais.relatorio': 'Transport invoices',
    'notasFiscais.resumo.notas': 'Invoices',
    'notasFiscais.resumo.semViagem': 'Without trip',
    'notasFiscais.resumo.emitentes': 'Issuers',
    'notasFiscais.dica': 'Captured by Qive and imported by Protheus, by issue date',
    'notasFiscais.filtro.de': 'From',
    'notasFiscais.filtro.ate': 'To',
    'notasFiscais.filtro.emitente': 'Issuer',
    'notasFiscais.filtro.uf': 'State',
    'notasFiscais.filtro.numero': 'Number',
    'notasFiscais.filtro.chave': 'Access key',
    'notasFiscais.filtro.viagem': 'Trip',
    'notasFiscais.filtro.todas': 'All',
    'notasFiscais.col.emissao': 'Issue date',
    'notasFiscais.col.numero': 'Number',
    'notasFiscais.col.emitente': 'Issuer',
    'notasFiscais.col.natureza': 'Nature of operation',
    'notasFiscais.col.chave': 'Access key',
    'notasFiscais.col.lote': 'Batch',
    'notasFiscais.col.viagem': 'Trip',
    'notasFiscais.cfop': 'CFOP {{cfop}}',
    'notasFiscais.semViagem': 'No trip',
    'notasFiscais.placa': 'Plate {{placa}}',
    'notasFiscais.foraDoModulo': 'Trip {{numero}} is not in the Trips module yet.',
    'notasFiscais.abrirViagem': 'Open the details of trip {{numero}}',
    'notasFiscais.vazio': 'No invoice in the filter.',
    'notasFiscais.export.dica': 'Downloads every invoice in the filter, not just the page.',
    'notasFiscais.export.vazio': 'No invoice to download in the filter.',
  },
  es: {
    'notasFiscais.titulo': 'Notas fiscales',
    'notasFiscais.eyebrow': 'Operación',
    'notasFiscais.relatorio': 'Notas fiscales de transporte',
    'notasFiscais.resumo.notas': 'Notas',
    'notasFiscais.resumo.semViagem': 'Sin viaje',
    'notasFiscais.resumo.emitentes': 'Emisores',
    'notasFiscais.dica': 'Capturadas por Qive e importadas por Protheus, por fecha de emisión',
    'notasFiscais.filtro.de': 'Desde',
    'notasFiscais.filtro.ate': 'Hasta',
    'notasFiscais.filtro.emitente': 'Emisor',
    'notasFiscais.filtro.uf': 'Estado',
    'notasFiscais.filtro.numero': 'Número',
    'notasFiscais.filtro.chave': 'Clave de acceso',
    'notasFiscais.filtro.viagem': 'Viaje',
    'notasFiscais.filtro.todas': 'Todas',
    'notasFiscais.col.emissao': 'Emisión',
    'notasFiscais.col.numero': 'Número',
    'notasFiscais.col.emitente': 'Emisor',
    'notasFiscais.col.natureza': 'Naturaleza de la operación',
    'notasFiscais.col.chave': 'Clave de acceso',
    'notasFiscais.col.lote': 'Lote',
    'notasFiscais.col.viagem': 'Viaje',
    'notasFiscais.cfop': 'CFOP {{cfop}}',
    'notasFiscais.semViagem': 'Sin viaje',
    'notasFiscais.placa': 'Placa {{placa}}',
    'notasFiscais.foraDoModulo': 'El viaje {{numero}} aún no está en el módulo de Viajes.',
    'notasFiscais.abrirViagem': 'Abrir el detalle del viaje {{numero}}',
    'notasFiscais.vazio': 'Ninguna nota fiscal en el filtro.',
    'notasFiscais.export.dica': 'Descarga todas las notas del filtro, y no solo la página.',
    'notasFiscais.export.vazio': 'Ninguna nota para descargar en el filtro.',
  },
}
